import { render, staticRenderFns } from "./layout-main.vue?vue&type=template&id=2b97a823&scoped=true"
import script from "./layout-main.vue?vue&type=script&lang=js"
export * from "./layout-main.vue?vue&type=script&lang=js"
import style0 from "./layout-main.vue?vue&type=style&index=0&id=2b97a823&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b97a823",
  null
  
)

export default component.exports